module.exports = __webpack_public_path__ + "img/advertising2.facd42ab.png";